import {Component, OnInit} from '@angular/core';
import {ClientMerchantsService} from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import {Router, ActivatedRoute} from '@angular/router';
import {CurrencyService} from 'src/app/services/manage/currency/currency.service';

import {TableReservationClientService} from 'src/app/services/apiclient/table-reservation/table-reservation.service';
import {TranslateService} from '@ngx-translate/core';
import {userAccountsDomainsService} from 'src/app/services/apiclient/userAccountsDomains/userAccountsDomains.service';
import {ToolsService} from 'src/app/services/tools/tools.service';
import {environment} from 'src/environments/environment';
import {CssService} from "../../../services/css-service";
import {forkJoin} from "rxjs";
import {FidelityService} from "../../../services/api/fidelity/fidelity.service";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ConfirmBlockCardComponent} from "../../dialogs/confirm-block-card/confirm-block-card.component";
import {ClientRefillsService} from "../../../services/apiclient/clientrefills/clientrefills.service";

interface ActionCard {
  title: string;
  description: string;
  icon: string;
  iconColor: string;
  clickAction: () => void;
  condition?: boolean;
  blocked?: boolean;
}

@Component({
  selector: 'app-merchant-options',
  templateUrl: './merchant-options.component.html',
  styleUrls: ['./merchant-options.component.css']
})

export class MerchantOptionsComponent implements OnInit {


  actionCards: ActionCard[] = [];
  currMerchant: any = null;
  getOffers: any = null;
  merchantClient: any;

  loaders = {
    page: true
  };

  merchantId: any = ""
  getBanner: any = ""
  resColsSpan = [1, 1, 1, 1];
  resRowsSpan = [2, 1, 1, 1]
  respCols: number = 2;
  respHeight: number = 200;
  BookingPoinfofsales: any;

  constructor(
    private clientMerchantApi: ClientMerchantsService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public cssService: CssService,
    public fidelityApi: FidelityService,
    private currencyMng: CurrencyService,
    private refillsApi: ClientRefillsService,
    private trApiClient: TableReservationClientService,
    public translate: TranslateService,
    private userAccountsDomainsService: userAccountsDomainsService,
    private tools: ToolsService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: any) => {
      if (params.merchantId) {
        this.merchantId = params.merchantId;
        this.initScreen();
      }
      // Pas d'id merchant
      else {
        this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);
      }
    });
  }

  initScreen(){

    forkJoin({
      merchant: this.clientMerchantApi.getMerchant(this.merchantId),
      client: this.clientMerchantApi.getMerchantClient(this.merchantId)
    }).subscribe(({merchant, client}) => {

      this.currMerchant = merchant;
      this.merchantClient = client;

      // Banniere par défaut
      this.initBanner();

      this.currencyMng.setCurrCurrency(merchant.currency);

      this.loaders.page = false;

      this.initActionsGrid();
      this.getFidelityOffers();

      // getBookingPointofSales
      if (this.currMerchant.options.includes(20)) {
        this.trApiClient.getBookingPointofSales(this.merchantId).then(trPointofsales => {
          this.BookingPoinfofsales = trPointofsales.booking_points_of_sale;
          this.loaders.page = false;
        });
      } else {
      }
    });
  }

  initActionsGrid() {

    const block = (this.merchantClient.archive === 0) ? true : false

    this.actionCards = [
      {
        title: 'Commandes',
        description: 'Passez une commande !',
        icon: 'fas fa-shopping-basket',
        iconColor: 'text-green-500',
        clickAction: () => this.goOrder(),
        condition: this.checkMerchantOptions(14)
      },
      {
        title: 'Réservations',
        description: 'Passez une réservation !',
        icon: 'fas fa-calendar-check',
        iconColor: 'text-blue-500',
        clickAction: () => this.goBooking(),
        condition: this.checkMerchantOptions(20)
      },
      {
        title: 'Cashless',
        description: 'Rechargez votre compte',
        icon: 'fas fa-credit-card',
        iconColor: 'text-purple-500',
        blocked: this.merchantClient.archive != 0,
        clickAction: () => this.goCashless(),
        condition: this.checkMerchantOptions(15) || this.checkMerchantOptions(2)
      },
      {
        title: 'Cashless',
        description: 'Bloquez votre carte cashless',
        icon: 'fas fa-ban',
        iconColor: 'text-red-500',
        clickAction: () => this.openConfirmBlockCard(),
        condition: block
      },
      {
        title: 'Transactions',
        description: 'Historique de vos achats',
        icon: 'fas fa-receipt',
        iconColor: 'text-indigo-500',
        clickAction: () => this.goHistory()
      },
    ];
  }

  initBanner() {
    if (this.currMerchant) {
      for (const pos of this.currMerchant.points_of_sale) {
        this.getBanner = this.currMerchant.points_of_sale[0].banner ? (this.getBannerLink(this.currMerchant.points_of_sale[0].banner, 1920)) : "";
        if (this.getBanner != '')
          return;
      }
    }
    return "";
  }

  getBannerLink(value: any, args?: any): any {
    const newValue = value.replace("%WIDTHx%HEIGHT", args + "x" + args);
    return newValue;
  }

  goCashless(): void {
    if(this.merchantClient.archive != 0){
      this.openConfirmBlockCard()
      return;
    }
    this.router.navigate(["/home/recharge" + "/" + this.currMerchant.id_user]);
  }

  goOrder(): void {

    // Récupération du nom de domaine perso
    this.userAccountsDomainsService.getUserAccountDomainByUser(this.currMerchant.id_user).subscribe((domain: any) => {
      if (domain && domain.domain) {
        let url = domain.domain == "localhost:4200" ? "http://" : "https://";
        url += domain.domain;
        url += domain.id_point_of_sale && domain.id_webshop ? "/s/" + this.currMerchant.url_encode + "/" + domain.id_webshop + "/" + domain.id_point_of_sale :
          "/p/" + this.currMerchant.url_encode + "/" + this.currMerchant.id_webshop;
        ;
        window.open(url, "_blank");
      } else {
        window.open("https://webshop.fulleapps.io" + "/p/" + this.currMerchant.url_encode + "/" + this.currMerchant.id_webshop, "_blank");
      }
    })
  }

  /**
   * Récupération des offres fidelité
   */
  getFidelityOffers(){
    // Si option fidelité
    if(this.checkMerchantOptions(13)){
      // Recup HTTP
      this.fidelityApi.$_getOffers(this.merchantClient.id, this.currMerchant.id_webshop).subscribe((r: any) => {
        this.getOffers = r
      });
    }
  }

  goFidelity(): void {
    this.router.navigate(["/home/fidelity/" + this.currMerchant.id_user]);
  }

  goBack(): void {
    this.router.navigate(["/home/dashboard"]);
  }

  goHistory(): void {
    this.router.navigate(["/home/notes/" + this.currMerchant.id_user]);
  }

  goHistoryCredit(): void {
    this.router.navigate(["/home/credits/" + this.currMerchant.id_user]);
  }

  goBooking(): void {
    this.BookingPoinfofsales.length > 1 ? this.router.navigate(["/home/bp/" + this.currMerchant.id_user]) : window.open(window.location.origin + "/tr/" + this.BookingPoinfofsales[0].url_encode + "/" + this.BookingPoinfofsales[0].id_webshop, "_blank");
  }

  checkMerchantOptions(optionId: number) {
    // debug, true
    if (!environment.production)
      return true;
    if (this.currMerchant) // 14: Order 15: Cashless
      return !!this.currMerchant.options.includes(optionId);
    return false;
  }

  openConfirmBlockCard(): void {
    const block = (this.merchantClient.archive === 0) ? true : false;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      block: block
    };
    const myDial = this.dialog.open(ConfirmBlockCardComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result)
        block ? this.blockCard() : this.unblockCard();
    });
  }

  blockCard(): void {
    this.loaders.page = true;
    this.refillsApi.blockCard(this.currMerchant.id_user).then(data => {
      if (data.code === 0) {
        this.merchantClient = data.client_user;
        this.initScreen()
      }
      this.loaders.page = false;
    });
  }

  unblockCard(): void {
    /*this.successMessage = null;
    this.errorMessage = null;
    this.statusMessage = this.translate.instant('cashlessOptionComponent.messageLoaderBlockCard');*/
    this.loaders.page = true;
    this.refillsApi.unblockCard(this.currMerchant.id_user).then(data => {
      if (data.code === 0) {
        this.merchantClient = data.client_user;
        this.initScreen()
        // Update merchant client
        //this.successMessage =this.translate.instant('cashlessOptionComponent.messageLoaderBlockCardSuccess');
      } else {
        //this.errorMessage = data.message;
      }
      this.loaders.page = false;
    });
  }
}


